import Node from './Node';

const NODE_KEY = 'id';
class Store {
  constructor(options) {
    this.currentNode = null;
    this.currentNodeKey = null;
    this.currentContextingNode = null;

    const keys = Object.keys(options);
    keys.forEach(name => {
      if (Object.prototype.hasOwnProperty.call(options, name)) {
        this[name] = options[name];
      }
    });

    this.nodesMap = {};

    this.root = new Node({
      data: this.data,
      store: this,
    });

    if (this.lazy) {
      this.root.initChildren(this.data);
    }
  }

  setData(newVal) {
    const instanceChanged = newVal !== this.root.data;
    if (instanceChanged) {
      this.root.setData(newVal);
    } else {
      this.root.updateChildren();
    }
  }

  updateChildren(key, data) {
    const node = this.nodesMap[key];
    if (!node) return;
    const { childNodes } = node;
    for (let i = childNodes.length - 1; i >= 0; i--) {
      const child = childNodes[i];
      this.remove(child.data);
    }
    for (let i = 0, j = data.length; i < j; i++) {
      const child = data[i];
      this.append(child, node.data);
    }
  }

  getNodeKey() {
    return this.nodeKey || NODE_KEY;
  }

  addNode(node) {
    const nodeKey = this.getNodeKey();
    this.nodesMap[node[nodeKey]] = node;
  }

  deleteNode(node) {
    const nodeKey = this.getNodeKey();
    node.childNodes.forEach(item => {
      this.deleteNode(item);
    });
    delete this.nodesMap[node[nodeKey]];
  }

  getNode(node) {
    if (node instanceof Node) {
      return node;
    }
    if (Array.isArray(node)) {
      return null;
    }
    const nodeKey = this.getNodeKey();
    return this.nodesMap[node[nodeKey]] || null;
  }

  getCurrentNode() {
    return this.currentNode;
  }

  setCurrentNode(node) {
    const prevCurrentNode = this.currentNode;
    if (prevCurrentNode) {
      prevCurrentNode.isCurrent = false;
    }
    this.currentNode = node;
    this.currentNode.isCurrent = true;
  }

  setCurrentContextingNode(node) {
    const prevCurrentNode = this.currentContextingNode;
    if (prevCurrentNode) {
      prevCurrentNode.isContexting = false;
    }
    this.currentContextingNode = node;
    node.isContexting = true;
  }

  getAllNodes() {
    const allNodes = [];
    const nodeKeys = Object.keys(this.nodesMap);
    nodeKeys.forEach(item => {
      allNodes.push(this.nodesMap[item]);
    });
    return allNodes.filter(item => item.level !== 0);
  }

  setChecked(nodeItem, val) {
    const node = this.getNode(nodeItem);
    node.setChecked(val);
  }

  getCheckedNodes() {
    const allNodes = this.getAllNodes();
    const checkedNodes = allNodes.filter(item => item.checked);
    return checkedNodes;
  }

  appendNode(parentNode, nodeInfo) {
    const node = this.getNode(parentNode);
    node.insertChild({ data: nodeInfo });
  }

  removeNode(nodeInfo) {
    const node = this.getNode(nodeInfo);
    node.remove();
  }

  setNode(nodeInfo, newInfo) {
    const node = this.getNode(nodeInfo);
    node.setNode(newInfo);
  }
}
export default Store;
